// eslint-disable-next-line import/prefer-default-export
export const TYPE = {
  SET: 'set',
  ITEM: 'item',
  COLOR: 'color',
};
